import { render, staticRenderFns } from "./unlink-social-modal.vue?vue&type=template&id=0c89bc18&"
import script from "./unlink-social-modal.vue?vue&type=script&lang=js&"
export * from "./unlink-social-modal.vue?vue&type=script&lang=js&"
import style0 from "./unlink-social-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports